import { render, staticRenderFns } from "./infoList.vue?vue&type=template&id=41e8733c&scoped=true&"
import script from "./infoList.vue?vue&type=script&lang=js&"
export * from "./infoList.vue?vue&type=script&lang=js&"
import style0 from "./infoList.vue?vue&type=style&index=0&id=41e8733c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41e8733c",
  null
  
)

export default component.exports